/* istanbul ignore file */
import { Component, Input } from '@angular/core';
import { IConnectedDevices, IPendingPhones } from 'src/app/model/sitefinity/IDashboard';

@Component({
  selector: 'app-connected-devices',
  templateUrl: './connected-devices.component.html',
  styleUrls: ['./connected-devices.component.scss']
})
export class ConnectedDevicesComponent {

  constructor(
  ) { }
}
